<template>
    <div>
        <div class="title">{{ message.title }}</div>
        <div class="content">
            <ul class="controls">
                <li>
                    <app-button
                        @click.native="select('yes')"
                        type="default"
                        align="center"
                    >Конечно!</app-button>
                </li>
                <li>
                    <app-button
                        @click.native="select('no')"
                        type="default"
                        align="center"
                    >Нет</app-button>
                </li>
            </ul>
            <div
                class="link ta-center"
                @click="finish"
            >Закончить тест</div>
        </div>
    </div>
</template>

<script>
    import AppButton from '@/components/AppButton.vue';

    export default {
        name: 'CategoryStep',
        components: {
            AppButton
        },
        computed: {
            category () {
                return this.$store.getters.getCategory;
            },
            message () {
                return this.$store.getters.getMessage;
            }
        },
        methods: {
            select (state) {
                this.$store.dispatch('setMessageState', state);
                if (!this.$store.getters.isStepsDone) {
                    this.$store.dispatch('nextMessage');
                }
            },

            finish () {
                this.$store.dispatch('setMessagesDone', true);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .title {
        margin-top: 1em;
        padding: 2em 1em;
        font-size: 2em;
        text-align: center;
        background-color: #9ecef5;
    }

    .controls {
        display: flex;
        margin-top: 3em;
        padding: 0;

        li {
            flex: 50%;
            list-style: none;
            margin: 1em 0;
        }
    }

    .link {
        margin-top: 4em;
    }

    @media screen and (max-width: 800px) {
        .controls {
            display: block;

            li {
                flex: none;
            }
        }
    }
</style>